
<!-- <div id="test"></div> -->

<div class="page-tabs-section">
    <div class="each-page-tab" [ngClass]="{'each-page-tab-selected': page_tab_selected == 'Activities'}" (click)="changePageTab('Activities')">
        <img src="assets/action-items.png" class="each-page-tab-icon" />
        <span>Activities</span>
    </div>
    <div class="each-page-tab" [ngClass]="{'each-page-tab-selected': page_tab_selected == 'Notifications'}" (click)="changePageTab('Notifications')">
        <img src="assets/notifications.png" class="each-page-tab-icon" />
        <span>Notifications</span>
    </div>
    <ng-container *ngIf="user_role == 'Relationship Manager' || user_role == 'Lending Officer' || user_role == 'Insurance Agent'">
      <div class="each-page-tab" [ngClass]="{'each-page-tab-selected': page_tab_selected == 'Results'}" (click)="changePageTab('Results')">
          <img src="assets/events.png" class="each-page-tab-icon" />
          <span>Results</span>
      </div>
    </ng-container>
</div>

<div class="page-tab-content-section">
    <ng-container *ngIf="page_tab_selected == 'Activities'">
        <ng-container>
            <div class="action-items-heading-section">
                <!-- <span class="action-items-heading" *ngIf="action_item_filter_tab_selected == 'day'">{{action_items_data.start_date | date: "d MMM yyyy"}}</span>
                <span class="action-items-heading" *ngIf="action_item_filter_tab_selected != 'day'">{{action_items_data.start_date | date: "d MMM yyyy"}} to {{action_items_data.end_date | date: "d MMM yyyy"}}</span> -->
                <div class="action-item-section">
                    <ng-container *ngFor="let filter_tab of action_item_filter_tabs">
                        <div class="each-action-item-filters-section" [ngClass]="{'each-action-item-filters-section-selected': action_item_filter_tab_selected.value == filter_tab.value}" (click)="changeActionItemDuration(filter_tab)">
                            <span>{{filter_tab.name}}</span>
                        </div>
                        <div class="filter-tab-date-section" *ngIf="action_item_filter_tab_selected.id == filter_tab.id">
                            <img src="assets/calendar-prev.png" class="filter-tab-date-icon" (click)="changeDuration('Previous')" />
                            <img src="assets/calendar-next.png" class="filter-tab-date-icon" (click)="changeDuration('Next')" />
                            <ng-container *ngIf="action_item_filter_tab_selected.value == 'day'">
                                <span class="filter-tab-date">{{selceted_activity_start_date | date: "dd MMM yyyy"}}</span>
                                <input
                                    type="text"
                                    bsDatepicker
                                    placement="right"
                                    [(ngModel)]="selceted_activity_start_date"
                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                    (ngModelChange)="changeDuration('Selected')"
                                    id="day-calendar-view"
                                    style="visibility: hidden; width: 0px;"
                                />
                                <label class="filter-tab-date-picker" for="day-calendar-view">
                                    <img src="assets/calendar.png" class="filter-tab-date-picker-image" />
                                </label>
                            </ng-container>
                            <ng-container *ngIf="action_item_filter_tab_selected.value == 'week'">
                                <!-- <label class="filter-tab-date" for="week-calendar-view">{{selceted_activity_start_date | date: "dd MMM yyyy"}}</label> -->
                                <span class="filter-tab-date">{{selceted_activity_start_date | date: "dd MMM yyyy"}}</span>
                                <span class="filter-tab-date">-</span>
                                <span class="filter-tab-date">{{selceted_activity_end_date | date: "dd MMM yyyy"}}</span>
                                <!-- <input
                                    type="text"
                                    bsDatepicker
                                    placement="right"
                                    [(ngModel)]="selceted_activity_start_date"
                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                    (ngModelChange)="changeDuration('Selected')"
                                    id="week-calendar-view"
                                    style="visibility: hidden; width: 0px;"
                                /> -->
                            </ng-container>
                            <ng-container *ngIf="action_item_filter_tab_selected.value == 'month'">
                                <span class="filter-tab-date">{{selceted_activity_start_date | date: "MMM yyyy"}}</span>
                                <input
                                    type="text"
                                    bsDatepicker
                                    placement="right"
                                    [(ngModel)]="selceted_activity_start_date"
                                    [minMode]="'month'"
                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                    (ngModelChange)="changeDuration('Selected')"
                                    id="month-calendar-view"
                                    style="visibility: hidden; width: 0px;"
                                />
                                <label class="filter-tab-date-picker" for="month-calendar-view">
                                    <img src="assets/calendar.png" class="filter-tab-date-picker-image" />
                                </label>
                            </ng-container>
                            <ng-container *ngIf="action_item_filter_tab_selected.value == 'year'">
                                <span class="filter-tab-date">{{selceted_activity_start_date | date: "yyyy"}}</span>
                                <input
                                    type="text"
                                    bsDatepicker
                                    placement="right"
                                    [(ngModel)]="selceted_activity_start_date"
                                    [minMode]="'year'"
                                    [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                                    (ngModelChange)="changeDuration('Selected')"
                                    id="year-calendar-view"
                                    style="visibility: hidden; width: 0px;"
                                />
                                <label class="filter-tab-date-picker" for="year-calendar-view">
                                    <img src="assets/calendar.png" class="filter-tab-date-picker-image" />
                                </label>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
                <div class="graphical-representation-swicth" *ngIf="action_items_data_loaded">
                    <div class="process-graph-switch">
                        <mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()"></mat-slide-toggle>
                    </div>
                    <span class="process-graph-switch-label" (click)="show_graphical_representation = !show_graphical_representation; toggleGraphs();">Graphical Representation</span>
                </div>
            </div>

            <!-- <div class="graphical-representation-section">
                <div class="graphical-representation-swicth">
                    <div class="process-graph-switch">
                        <mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()"></mat-slide-toggle>
                    </div>
                    <span class="process-graph-switch-label">Graphical Representation</span>
                </div>
            </div> -->

            <ng-container *ngIf="action_items_data_loaded">

                <div class="to-do-filter-section">
                    <div class="to-do-filter-input-section " *ngIf="user_role != 'Marketing Team'">
                        <p class="to-do-filter-input-label">Type</p>
                        <mat-select class="to-do-filter-input" [(ngModel)]="activity_type_filter" (selectionChange)="getActionItemGraphs()">
                            <mat-option [value]="'All'">All</mat-option>
                            <!-- <ng-container *ngIf="user_role != 'Executive' && user_role != 'Leadership'"> -->
                            <ng-container *ngIf="user_role != 'Executive'">
                                <mat-option [value]="'Automated'">Automated</mat-option>
                                <mat-option [value]="'Manual'">Manual</mat-option>
                            </ng-container>
                            <!-- <ng-container *ngIf="user_role == 'Executive' || user_role == 'Leadership'"> -->
                            <ng-container *ngIf="user_role == 'Executive'">
                                <mat-option [value]="'Branch'">Branch</mat-option>
                                <mat-option [value]="'Product'">Product</mat-option>
                                <!-- <mat-option [value]="'Advisor Manager'">Advisor Manager</mat-option> -->
                                <mat-option [value]="'Advisor Manager'">Advisor Success Coach</mat-option>
                                <mat-option [value]="'Advisor'">Advisor</mat-option>
                            </ng-container>
                        </mat-select>
                    </div>
                    <div class="to-do-filter-input-section" *ngIf="user_role != 'Executive' && user_role != 'Marketing Team'">
                        <p class="to-do-filter-input-label">Importance</p>
                        <mat-select class="to-do-filter-input" [(ngModel)]="importance_filter" (selectionChange)="getActionItemGraphs()">
                            <mat-option [value]="'All'">All</mat-option>
                            <mat-option [value]="'Low'">Low</mat-option>
                            <mat-option [value]="'Medium'">Medium</mat-option>
                            <mat-option [value]="'High'">High</mat-option>
                        </mat-select>
                    </div>
                    <div class="to-do-filter-input-section" *ngIf="user_role == 'Advisor Manager'">
                        <p class="to-do-filter-input-label">Activity Stage</p>
                        <mat-select class="to-do-filter-input" [(ngModel)]="activity_stage_filter" (selectionChange)="getActionItemGraphs()">
                            <mat-option [value]="'All'">All</mat-option>
                            <mat-option [value]="1">General</mat-option>
                            <mat-option [value]="3">Coaching Plan</mat-option>
                            <mat-option [value]="4">Coaching Plan Follow Up</mat-option>
                            <mat-option [value]="2">Advisor Attrition</mat-option>
                            <mat-option [value]="6">Advisor Focus Area</mat-option>
                            <mat-option [value]="7">Advisor Workload Management</mat-option>
                            <mat-option [value]="8">Performance</mat-option>
                            <mat-option [value]="9">Single Product Selling Advisor</mat-option>
                        </mat-select>
                    </div>
                    <!-- <div class="to-do-filter-input-section" *ngIf="user_role != 'Advisor Manager'">
                        <p class="to-do-filter-input-label">Activity Stage</p>
                        <mat-select class="to-do-filter-input" [(ngModel)]="activity_stage_filter" (selectionChange)="getActionItemGraphs()">
                            <mat-option [value]="'All'">All</mat-option>
                            <mat-option [value]="'Pitch(Sales)'">Pitch(Sales)</mat-option>
                            <mat-option [value]="'Follow Up(Sales)'">Follow Up(Sales)</mat-option>
                            <mat-option [value]="'Pitch(Retention)'">Pitch(Retention)</mat-option>
                            <mat-option [value]="'Follow Up(Retention)'">Follow Up(Retention)</mat-option>
                            <mat-option class="capitalize" *ngFor="let stage of stages_list" [value]="stage.id">{{stage.name}} ({{stage.type}})</mat-option>
                        </mat-select>
                    </div> -->
                    <div class="to-do-filter-input-section" *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team' && user_role != 'Wholesaler'">
                        <p class="to-do-filter-input-label">Client Stage</p>
                        <mat-select class="to-do-filter-input" [(ngModel)]="client_stage_filter" (selectionChange)="getActionItemGraphs()">
                            <mat-option [value]="'All'">All</mat-option>
                            <!-- <mat-option [value]="'Pitch(Sales)'">Pitch(Sales)</mat-option>
                            <mat-option [value]="'Follow Up(Sales)'">Follow Up(Sales)</mat-option>
                            <mat-option [value]="'Pitch(Retention)'">Pitch(Retention)</mat-option>
                            <mat-option [value]="'Follow Up(Retention)'">Follow Up(Retention)</mat-option> -->
                            <mat-option class="capitalize" *ngFor="let stage of stages_list" [value]="stage.id">{{stage.name}} ({{stage.type}})</mat-option>
                        </mat-select>
                    </div>
                    <div class="to-do-filter-input-section">
                        <p class="to-do-filter-input-label">Status</p>
                        <mat-select class="to-do-filter-input" [(ngModel)]="status_filter" (selectionChange)="getActionItemGraphs()">
                            <mat-option [value]="'All'">All</mat-option>
                            <mat-option *ngFor="let status of status_list" [value]="status.id" >{{ status.name }}</mat-option>
                        </mat-select>
                    </div>
                    <div class="to-do-filter-input-section" *ngIf="user_role == 'Advisor'">
                        <p class="to-do-filter-input-label">Assigned Assistant</p>
                        <mat-select class="to-do-filter-input" [(ngModel)]="assigned_filter" (selectionChange)="getActionItemGraphs()">
                            <mat-option [value]="'All'">All</mat-option>
                            <mat-option [value]="'Yes'">Yes</mat-option>
                            <mat-option [value]="'No'">No</mat-option>
                        </mat-select>
                    </div>
                </div>

                <div class="action-items-summary-section gap-between">
                    <div class="each-action-items-summary-section" *ngFor="let summary of action_items_data['summary']">
                        <p class="each-action-items-summary-label">{{summary.name}}</p>
                        <p class="each-action-items-summary-count">
                            {{summary.current_value}}
                            <span *ngIf="summary.show_aum">({{summary.aum}})</span>
                        </p>
                        <p class="each-action-items-summary-description">
                            <span class="each-action-items-summary-tag loss-tag" [ngClass]="{'growth-tag': summary.growth}">
                                <img src="assets/growth-up.png" *ngIf="summary.growth"/>
                                <img src="assets/growth-down.png" *ngIf="!summary.growth"/>
                                {{summary.growth_value}}
                            </span>
                            vs previous  (<strong>{{summary.previous_value}}</strong>)
                        </p>
                    </div>
                </div>

                <div class="each-page-tab-content-section" *ngIf="show_graphical_representation">
                    <div class="page-graph-filters-section">

                        <span class="new-filter-tag" *ngIf="graph_activity_status_id != ''">
                            Status - {{ graph_activity_status }}
                            <img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="graph_activity_status_id = ''; graph_activity_status = ''; getActionItemGraphs();" />
                        </span>

                        <span class="new-filter-tag" *ngIf="graph_activity_communication_channel_id != ''">
                            Communication Channel - {{ graph_activity_communication_channel }}
                            <img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="graph_activity_communication_channel_id = ''; graph_activity_communication_channel = ''; getActionItemGraphs();" />
                        </span>

                        <span class="new-filter-tag" *ngIf="graph_activity_duration_id != ''">
                            Duration - {{ graph_activity_duration }}
                            <img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="graph_activity_duration_id = ''; graph_activity_duration = ''; getActionItemGraphs();" />
                        </span>

                        <span class="new-filter-tag" *ngIf="graph_activity_importance_id != ''">
                            Importance - {{ graph_activity_importance }}
                            <img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="graph_activity_importance_id = ''; graph_activity_importance = ''; getActionItemGraphs();" />
                        </span>

                        <span class="new-filter-tag" *ngIf="graph_activity_type_id != ''">
                            Type - {{ graph_activity_type }}
                            <img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="graph_activity_type_id = ''; graph_activity_type = ''; getActionItemGraphs();" />
                        </span>

                    </div>

                    <div class="page-graphs-section">
                        <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>Activities by Status</span>
                            </div>
                            <div class="each-dashboard-graph-content" style="max-height: 360px; overflow-y: auto;">
                                <div class="each-graph-status-section" *ngFor="let status of action_items_data['new_status_graph']">
                                    <div class="each-graph-status-label">
                                        <span>{{status.name}}</span>
                                    </div>
                                    <div class="each-graph-status-bar">
                                        <div class="each-graph-status-inner-bar" [style.background]="status.color"  [style.width]="status.width + '%'"></div>
                                    </div>
                                    <div class="each-graph-status-value-section">
                                        <div class="each-graph-status-value" [style.background]="status.color">{{commonService.abbreviateNumber(status.value)}}</div>
                                    </div>
                                    <div class="each-graph-status-tooltip-section">
                                        <div class="each-graph-status-tooltip-heading-section">
                                            <span class="each-graph-status-tooltip-heading">{{status.name}}</span>
                                            <span class="each-graph-status-tooltip-heading-value">{{status.value}}</span>
                                        </div>

                                        <div class="each-graph-status-detail-section" *ngFor="let channel of status.breakdown">
                                            <span class="each-graph-status-detail-label">{{channel.name}}</span>
                                            <span class="each-graph-status-detail-count">{{channel.count}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>Activities by Duration</span>
                            </div>
                            <div class="each-dashboard-graph-content">
                                <div id="channel-duration-graph"></div>
                            </div>
                        </div>

                        <ng-container *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team' && user_role != 'Assistant' && user_role != 'Wholesaler'">
                            <div class="each-dashboard-graph-block">
                                <div class="graph-inner-heading-section">
                                    <img src="assets/events.png" class="graph-section-icon" />
                                    <span>Activities by Sales Process</span>
                                </div>
                                <div class="each-dashboard-graph-content">
                                    <div class="stage-graph-tabs-section">
                                        <div class="each-stage-graph-tab" [ngClass]="{'each-stage-graph-tab-selected': selcted_graph_stage == 'Upside'}" (click)="selcted_graph_stage = 'Upside'; createStagesGraph()">
                                            <span>Upside</span>
                                        </div>
                                        <div class="each-stage-graph-tab" [ngClass]="{'each-stage-graph-tab-selected': selcted_graph_stage == 'Retention'}" (click)="selcted_graph_stage = 'Retention'; createStagesGraph()">
                                            <span>Retention</span>
                                        </div>
                                        <div class="each-stage-graph-tab" [ngClass]="{'each-stage-graph-tab-selected': selcted_graph_stage == 'New'}" (click)="selcted_graph_stage = 'New'; createStagesGraph()">
                                            <span>New</span>
                                        </div>
                                    </div>
                                    <div id="sale-process-graph"></div>
                                </div>
                            </div>
                        </ng-container>

                        <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>Activities by Communication Channel</span>
                            </div>
                            <div class="each-dashboard-graph-content" style="padding: 0;">
                                <div id="activity-channel-graph"></div>
                            </div>
                        </div>

                        <ng-container *ngIf="user_role == 'Advisor Manager' || user_role == 'Assistant'">
                            <div class="each-dashboard-graph-block">
                                <div class="graph-inner-heading-section">
                                    <img src="assets/events.png" class="graph-section-icon" />
                                    <span>Activities Stages</span>
                                </div>
                                <div class="each-dashboard-graph-content">
                                    <div id="activity-stages-graph"></div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team' && user_role != 'Assistant'">
                            <div class="each-dashboard-graph-block">
                                <div class="graph-inner-heading-section">
                                    <img src="assets/events.png" class="graph-section-icon" />
                                    <span>Activities by Type</span>
                                </div>
                                <div class="each-dashboard-graph-content">
                                    <div id="activity-type-graph"></div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Marketing Team' && user_role != 'Assistant' && user_role != 'Wholesaler'">
                            <div class="each-dashboard-graph-block">
                                <div class="graph-inner-heading-section">
                                    <img src="assets/events.png" class="graph-section-icon" />
                                    <!-- <span>Activities by AI Assistant</span> -->
                                    <span>Activities by MAGI</span>
                                </div>
                                <div class="each-dashboard-graph-content">
                                    <div id="ai-assistant-graph"></div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>Activities by Status</span>
                            </div>
                            <div class="each-dashboard-graph-content">
                                <div id="activity-status-graph"></div>
                            </div>
                        </div>

                        <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>Activities by Communication Channel & Status</span>
                            </div>
                            <div class="each-dashboard-graph-content">
                                <div id="channel-status-graph"></div>
                            </div>
                        </div>

                        <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>Activities by Communication Channel & Duration</span>
                            </div>
                            <div class="each-dashboard-graph-content">
                                <div id="channel-duration-graph"></div>
                            </div>
                        </div>

                        <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>Activities by Communication Channel & Importance</span>
                            </div>
                            <div class="each-dashboard-graph-content">
                                <div id="channel-importance-graph"></div>
                            </div>
                        </div>

                        <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>Activities by Communication Channel & Stage</span>
                            </div>
                            <div class="each-dashboard-graph-content">
                                <div id="channel-stage-graph"></div>
                            </div>
                        </div>

                        <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>Activities by Type</span>
                            </div>
                            <div class="each-dashboard-graph-content">
                                <div id="activity-type-graph"></div>
                            </div>
                        </div>

                        <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>Top Trends</span>
                            </div>
                            <div class="each-dashboard-graph-content">
                                <div id="top-trends-graph"></div>
                            </div>
                        </div>

                        <div class="each-dashboard-graph-block">
                            <div class="graph-inner-heading-section">
                                <img src="assets/events.png" class="graph-section-icon" />
                                <span>AI Assistant</span>
                                <span>MAGI</span>
                            </div>
                            <div class="each-dashboard-graph-content">
                                <div id="ai-assistant-graph"></div>
                            </div>
                        </div> -->

                    </div>
                </div>

                <div style="text-align: right; margin-bottom: 24px;" *ngIf="user_details.role.role == 5 || user_details.role.role == 6">
                    <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-button">
                        <img src="assets/phone-new.png" class="menu-button-icon" />
                        <span>High Valued Opportunities</span>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item class="each-menu-item" (click)="navigateToHighValuedOpportunities('upside-opportunities', 2)">
                            <span>Upside</span>
                        </button>
                        <button mat-menu-item class="each-menu-item" (click)="navigateToHighValuedOpportunities('retention-opportunities', 2)">
                            <span>Retention</span>
                        </button>
                        <button mat-menu-item class="each-menu-item" (click)="navigateToHighValuedOpportunities('bank-investment-clients', 2)">
                            <span>Bank</span>
                        </button>
                        <button mat-menu-item class="each-menu-item" (click)="navigateToHighValuedOpportunities('new-prospects', 2)">
                            <span>New Prospects</span>
                        </button>
                    </mat-menu>

                    <!-- <div class="each-action-item-filters-section each-action-item-filters-section-selected" (click)="navigateToHighValuedOpportunities('upside-opportunities', 2)">
                        <span>High Valued Opportunities</span>
                    </div>
                    <div class="each-action-item-filters-section each-action-item-filters-section-selected" (click)="navigateToHighValuedOpportunities('retention-opportunities', 2)">
                        <span>Clients at Risk</span>
                    </div>
                    <div class="each-action-item-filters-section each-action-item-filters-section-selected" (click)="navigateToHighValuedOpportunities('bank-investment-clients', 3)">
                        <span>Bank to Investment Clients</span>
                    </div>
                    <div class="each-action-item-filters-section each-action-item-filters-section-selected" (click)="navigateToHighValuedOpportunities('new-prospects', 3)">
                        <span>New Prospects</span>
                    </div> -->
                </div>

                <div class="each-page-tab-content-section">
                    <div class="to-do-tabs-section">
                        <span class="to-do-tab" *ngFor="let action_item_tab of action_item_tabs" [ngClass]="{ 'to-do-tab-selected': action_item_tab_selected == action_item_tab.value }" (click)="changeActionItemTab(action_item_tab);" >{{action_item_tab.name}}</span>
                    </div>
                    <ng-container *ngIf="action_items_table_data_loaded">
                        <app-activity-table [activities_table_header]="activities_table_header" [activities_table_data]="action_items_table_data" [view_type]="'Action Items'" [activity_action_type]="'Edit'" (activityDetailsUpdated)="activityDetailsUpdated($event)"></app-activity-table>
                    </ng-container>
                    <ng-container *ngIf="!action_items_table_data_loaded">
                        <app-loader [loading_text]="'Loading Action Items'"></app-loader>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="!action_items_data_loaded">
            <app-loader [loading_text]="'Loading Action Items'"></app-loader>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="page_tab_selected == 'Notifications'">
        <div class="to-do-tabs-section">
            <span class="to-do-tab" *ngFor="let notification_tab of notification_tabs" [ngClass]="{ 'to-do-tab-selected': notification_tab_selected == notification_tab.value }" (click)="changeNotificationTab(notification_tab);" >{{notification_tab.name}}</span>
        </div>

        <div class="to-do-filter-section" *ngIf="notification_tab_selected == notification_tabs[1].value">
            <div class="to-do-filter-input-section" *ngIf="user_role != 'Marketing Team'">
                <p class="to-do-filter-input-label">Type</p>
                <mat-select class="to-do-filter-input" [(ngModel)]="activity_type_filter" (selectionChange)="getNotifications()">
                    <mat-option [value]="'All'">All</mat-option>
                    <!-- <ng-container *ngIf="user_role != 'Executive' && user_role != 'Leadership'"> -->
                    <ng-container *ngIf="user_role != 'Executive'">
                        <mat-option [value]="'Automated'">Automated</mat-option>
                        <mat-option [value]="'Manual'">Manual</mat-option>
                    </ng-container>
                    <!-- <ng-container *ngIf="user_role == 'Executive' || user_role == 'Leadership'"> -->
                    <ng-container *ngIf="user_role == 'Executive'">
                        <mat-option [value]="'Branch'">Branch</mat-option>
                        <mat-option [value]="'Product'">Product</mat-option>
                        <mat-option [value]="'Advisor Manager'">Advisor Success Coach</mat-option>
                        <mat-option [value]="'Advisor'">Advisor</mat-option>
                    </ng-container>
                </mat-select>
            </div>
            <div class="to-do-filter-input-section" *ngIf="user_role != 'Executive' && user_role != 'Marketing Team'">
                <p class="to-do-filter-input-label">Importance</p>
                <mat-select class="to-do-filter-input" [(ngModel)]="importance_filter" (selectionChange)="getNotifications()">
                    <mat-option [value]="'All'">All</mat-option>
                    <mat-option [value]="'Low'">Low</mat-option>
                    <mat-option [value]="'Medium'">Medium</mat-option>
                    <mat-option [value]="'High'">High</mat-option>
                </mat-select>
            </div>
            <div class="to-do-filter-input-section" *ngIf="user_role == 'Advisor Manager'">
                <p class="to-do-filter-input-label">Activity Stage</p>
                <mat-select class="to-do-filter-input" [(ngModel)]="activity_stage_filter" (selectionChange)="getNotifications()">
                    <mat-option [value]="'All'">All</mat-option>
                    <mat-option [value]="1">General</mat-option>
                    <mat-option [value]="3">Coaching Plan</mat-option>
                    <mat-option [value]="4">Coaching Plan Follow Up</mat-option>
                    <mat-option [value]="2">Advisor Attrition</mat-option>
                    <mat-option [value]="6">Advisor Focus Area</mat-option>
                    <mat-option [value]="7">Advisor Workload Management</mat-option>
                    <mat-option [value]="8">Performance</mat-option>
                    <mat-option [value]="9">Single Product Selling Advisor</mat-option>
                </mat-select>
            </div>
            <!-- <div class="to-do-filter-input-section" *ngIf="user_role != 'Advisor Manager'">
                <p class="to-do-filter-input-label">Activity Stage</p>
                <mat-select class="to-do-filter-input" [(ngModel)]="activity_stage_filter" (selectionChange)="getNotifications()">
                    <mat-option [value]="'All'">All</mat-option>
                    <mat-option [value]="'Pitch(Sales)'">Pitch(Sales)</mat-option>
                    <mat-option [value]="'Follow Up(Sales)'">Follow Up(Sales)</mat-option>
                    <mat-option [value]="'Pitch(Retention)'">Pitch(Retention)</mat-option>
                    <mat-option [value]="'Follow Up(Retention)'">Follow Up(Retention)</mat-option>
                    <mat-option class="capitalize" *ngFor="let stage of stages_list" [value]="stage.id">{{stage.name}} ({{stage.type}})</mat-option>
                </mat-select>
            </div> -->
            <div class="to-do-filter-input-section" *ngIf="user_role != 'Advisor Manager' && user_role != 'Executive' && user_role != 'Leadership' && user_role != 'Marketing Team' && user_role != 'Wholesaler'">
                <p class="to-do-filter-input-label">Client Stage</p>
                <mat-select class="to-do-filter-input" [(ngModel)]="client_stage_filter" (selectionChange)="getNotifications()">
                    <mat-option [value]="'All'">All</mat-option>
                    <!-- <mat-option [value]="'Pitch(Sales)'">Pitch(Sales)</mat-option>
                    <mat-option [value]="'Follow Up(Sales)'">Follow Up(Sales)</mat-option>
                    <mat-option [value]="'Pitch(Retention)'">Pitch(Retention)</mat-option>
                    <mat-option [value]="'Follow Up(Retention)'">Follow Up(Retention)</mat-option> -->
                    <mat-option class="capitalize" *ngFor="let stage of stages_list" [value]="stage.id">{{stage.name}} ({{stage.type}})</mat-option>
                </mat-select>
            </div>
            <div class="to-do-filter-input-section">
                <p class="to-do-filter-input-label">Status</p>
                <mat-select class="to-do-filter-input" [(ngModel)]="status_filter" (selectionChange)="getNotifications()">
                    <mat-option [value]="'All'">All</mat-option>
                    <mat-option *ngFor="let status of status_list" [value]="status.id" >{{ status.name }}</mat-option>
                </mat-select>
            </div>
            <div class="to-do-filter-input-section" *ngIf="user_role == 'Advisor'">
                <p class="to-do-filter-input-label">Assigned Assistant</p>
                <mat-select class="to-do-filter-input" [(ngModel)]="assigned_filter" (selectionChange)="getNotifications()">
                    <mat-option [value]="'All'">All</mat-option>
                    <mat-option [value]="'Yes'">Yes</mat-option>
                    <mat-option [value]="'No'">No</mat-option>
                </mat-select>
            </div>
        </div>

        <ng-container *ngIf="notifications_data_loaded">
            <ng-container *ngIf="notification_tab_selected == notification_tabs[0].value">
                <div class="each-page-tab-content-section" *ngIf="notifications_data['gen_notifications'].length > 0">
                    <!-- <div class="each-notification-detail-section" *ngFor="let notification of notifications_data['gen_notifications']">
                        <div class="each-notification-detail-content-section">
                            <img src="assets/internal-notification.png" class="notification-detail-image" />
                            <span>{{ notification.content }}</span>
                            <span [innerHTML]="notification.content"></span>
                        </div>
                    </div> -->
                    <div class="each-notification-detail-section-v2" *ngFor="let notification of notifications_data['gen_notifications']">
                        <div class="each-notification-v2-icon-section">
                            <img src="assets/internal-notification.png" class="each-notification-v2-icon" />
                        </div>
                        <div class="each-notification-v2-content-section">
                            <p class="each-notification-v2-title">{{notification.title}}</p>
                            <p class="each-notification-v2-description" [innerHTML]="notification.content"></p>
                        </div>
                        <div class="each-notification-v2-date-section">
                            <span>{{notification.fired_date | date: 'MMM d, y, h:mm a'}}</span>
                        </div>
                    </div>
                </div>
                <div class="notification-zero-state" *ngIf="notifications_data['gen_notifications'].length == 0">
                    <span>No Notifications Found</span>
                </div>
            </ng-container>
            <ng-container *ngIf="notification_tab_selected == notification_tabs[1].value">
                <app-activity-table [activities_table_header]="activities_table_header" [activities_table_data]="notifications_data['pending_items']" [view_type]="'Action Items'" [activity_action_type]="'Edit'" (activityDetailsUpdated)="activityDetailsUpdated($event)"></app-activity-table>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="!notifications_data_loaded">
            <app-loader [loading_text]="'Loading Notifications'"></app-loader>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="page_tab_selected == 'Results'">
      <ng-container *ngIf="results_data_loaded">

                <div class="to-do-filter-section">
                    <div class="to-do-filter-input-section">
                        <p class="to-do-filter-input-label">Duration</p>
                        <mat-select class="to-do-filter-input" [(ngModel)]="results_duration_filter" (selectionChange)="getResultsData()">
                            <mat-option [value]="'previous_year'">Previous Year</mat-option>
                            <mat-option [value]="'current_year'">Current Year</mat-option>
                            <mat-option [value]="'next_year'">2 Years</mat-option>
                            <mat-option [value]="'next_two_years'">3 Years</mat-option>
                            <mat-option [value]="'next_three_years'">4 Years</mat-option>
                        </mat-select>
                    </div>
                </div>

                <div class="action-items-summary-section gap-between">
                    <div class="each-action-items-summary-section" *ngFor="let summary of results_data['data']">
                        <p class="each-action-items-summary-label">{{summary.segment}}</p>
                        <p class="each-action-items-summary-count">{{summary.value}}</p>
                        <!-- <div class="each-action-items-summary-description">
                          <ng-container *ngIf="summary.show">
                            <mat-select class="to-do-filter-input" [(ngModel)]="summary.action" (selectionChange)="changeResultAction(summary)">
                              <mat-option [value]="''" >Select Action</mat-option>
                              <mat-option [value]="'Next Campaign'" >Next Campaign</mat-option>
                              <mat-option [value]="'Assign to Call Center'" >Assign to Call Center</mat-option>
                              <mat-option [value]="'Send a follow up mail'" >Send a follow up mail</mat-option>
                            </mat-select>
                          </ng-container>
                        </div> -->
                    </div>
                </div>

                <div class="results-information-section">
                  <table class="results-table">
                    <thead>
                      <tr>
                        <th style="width: 40%;">Name</th>
                        <th style="width: 30%;">Count</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let summary of results_data['table']">
                        <td>{{summary.segment}}</td>
                        <td>{{summary.value}}</td>
                        <td>
                          <ng-container *ngIf="summary.show">
                              <mat-select class="to-do-filter-input" [(ngModel)]="summary.action" (selectionChange)="changeResultAction(summary)" [readOnly]="summary.action != ''" [disabled]="summary.action != ''">
                                <mat-option [value]="''" >Select Action</mat-option>
                                <mat-option [value]="'Next Campaign'" >Next Campaign</mat-option>
                                <mat-option [value]="'Assign to Call Center'" >Assign to Call Center</mat-option>
                                <mat-option [value]="'Send a follow up mail'" >Send a follow up mail</mat-option>
                            </mat-select>
                            </ng-container>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="results-information-section">
                  <div id="results-graph"></div>
                </div>

              </ng-container>
              <ng-container *ngIf="!results_data_loaded">
                <app-loader [loading_text]="'Loading Results'"></app-loader>
              </ng-container>

    </ng-container>
</div>
